import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConnectComponent } from '../../modals/connect/connect.component';
import { EventService } from '../../services/event.service';

export const faqLists = [
  {
    heading: 'faq.faq_1',
    content: 'faq.faq_cont_1',
  },
  {
    heading: 'faq.faq_2',
    content: 'faq.faq_cont_2',
  },
  {
    heading: 'faq.faq_3',
    content: 'faq.faq_cont_3',
  },
  {
    heading: 'faq.faq_4',
    content: 'faq.faq_cont_4',
  },
];

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent {
  items = [...faqLists];
  modalRef?: BsModalRef;

  constructor(
    private eventService: EventService,
    private modalService: BsModalService,
  ) { }


  showWidget(section: string): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.eventService.showBuyWidget(section);
  }

  connectModal(): void {
    this.modalRef = this.modalService.show(ConnectComponent, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }
}
